import { Table as ChakraTableNamespace } from '@chakra-ui/react';

export type TableProps = ChakraTableNamespace.RootProps;
export const Table = ChakraTableNamespace.Root;

export type TrProps = ChakraTableNamespace.RowProps;
export const Tr = ChakraTableNamespace.Row;

export interface TdProps extends ChakraTableNamespace.CellProps {
  isNumeric?: boolean;
  ref?: React.RefObject<HTMLTableCellElement | null>;
}
export function Td({ ref, ...props }: TdProps) {
  const { children, ...rest } = props;

  return (
    <ChakraTableNamespace.Cell {...rest} textAlign={props.isNumeric ? 'right' : 'left'} ref={ref}>
      {children}
    </ChakraTableNamespace.Cell>
  );
}

export interface ThProps extends ChakraTableNamespace.ColumnHeaderProps {
  isNumeric?: boolean;
  ref?: React.RefObject<HTMLTableCellElement | null>;
}
export function Th({ ref, ...props }: ThProps) {
  return <ChakraTableNamespace.ColumnHeader {...props} textAlign={props.isNumeric ? 'right' : 'left'} ref={ref} />;
}

export type TbodyProps = ChakraTableNamespace.BodyProps;
export const Tbody = ChakraTableNamespace.Body;

export type TFootProps = ChakraTableNamespace.FooterProps;
export const Tfoot = ChakraTableNamespace.Footer;

export type TheadProps = ChakraTableNamespace.HeaderProps;
export const Thead = ChakraTableNamespace.Header;
